<div id="{{sidePanelId}}" [ngClass]="{'in-view': _showPanel}" class="with-help-text {{ sidePanelClass }}">
  <div class="cs-sidepanel-parentcontainer">
    <!-- Panel content goes here -->
    <ng-content></ng-content>
  </div>
</div>

<!--Backdrop-->
<div *ngIf="_showPanel" id="page-overlay" [ngClass]="{'in-view': sidePanelIsShowing}"></div>
